export default {
  meta: {
    title: '商场决策报告',
    parentPath: '/share',
    breadcrumbs: [],
  },
};
